<template>
    <div v-if="template" v-route-title="'预览'+template.name">
        <component v-if="pageType" :is="pageType.preview||pageType.component" :id="id" :is-template="true"></component>
    </div>
</template>

<script>
    import pageTemplateService from '../service/page-template'
    import pageTypeService from '../service/page-type'

    export default {
        name: "PreviewTemplate",
        props: ["id"],
        data() {
            return {
                template: null,
                pageType: null
            }
        },
        created(){
            pageTemplateService.getPageTemplate(this.id).then(response => {
                this.template = response.data
                this.pageType = pageTypeService.getPageType(this.template.pageType)
            })
        }
    }
</script>
<style scoped>

</style>
